import { axiosApiInstance } from './axios';

const apiRoot = '';

const factoryFilesApi = {
  get: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/factoryFiles`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  create: async (data) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/factoryFiles`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  delete: async (id) => {
    try {
      const res = await axiosApiInstance.delete(`${apiRoot}/factoryFiles/${id}`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  update: async (id, data) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/factoryFiles/${id}`, data);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default factoryFilesApi;
